// contexts/SpotlightProvider.tsx
import React, { type ReactNode, useCallback, useState } from 'react';
import { SpotlightContext } from './SpotlightContext';
import type { WidgetHelpData } from '@/types/dashboard';

export const SpotlightProvider = ({ children }: { children: ReactNode }) => {
    const [activeWidgetId, setActiveWidgetId] = useState<string | null>(null);
    const [helpData, setHelpData] = useState<WidgetHelpData | null>(null);
    const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

    const openSpotlight = useCallback((widgetId: string, data: WidgetHelpData, el: HTMLElement) => {
        setActiveWidgetId(widgetId);
        setHelpData(data);
        setAnchorEl(el);
        el.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }, []);

    const closeSpotlight = useCallback(() => {
        setActiveWidgetId(null);
        setHelpData(null);
        setAnchorEl(null);
    }, []);

    return (
        <SpotlightContext.Provider value={{ activeWidgetId, helpData, anchorEl, openSpotlight, closeSpotlight }}>
            {children}
        </SpotlightContext.Provider>
    );
};
